/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  ThirdwebContract,
  ThirdwebContractInterface,
} from "../ThirdwebContract";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "prevOwner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnerUpdated",
    type: "event",
  },
  {
    inputs: [],
    name: "contractURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getPublishMetadataUri",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_uri",
        type: "string",
      },
    ],
    name: "setContractURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_newOwner",
        type: "address",
      },
    ],
    name: "setOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "string",
            name: "publishMetadataUri",
            type: "string",
          },
          {
            internalType: "string",
            name: "contractURI",
            type: "string",
          },
          {
            internalType: "address",
            name: "owner",
            type: "address",
          },
        ],
        internalType: "struct ThirdwebContract.ThirdwebInfo",
        name: "_thirdwebInfo",
        type: "tuple",
      },
    ],
    name: "setThirdwebInfo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type ThirdwebContractConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ThirdwebContractConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ThirdwebContract__factory extends ContractFactory {
  constructor(...args: ThirdwebContractConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ThirdwebContract> {
    return super.deploy(overrides || {}) as Promise<ThirdwebContract>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): ThirdwebContract {
    return super.attach(address) as ThirdwebContract;
  }
  override connect(signer: Signer): ThirdwebContract__factory {
    return super.connect(signer) as ThirdwebContract__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ThirdwebContractInterface {
    return new utils.Interface(_abi) as ThirdwebContractInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ThirdwebContract {
    return new Contract(address, _abi, signerOrProvider) as ThirdwebContract;
  }
}
